import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/user/rpauser/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/user/rpauser/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/user/rpauser/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/user/rpauser/submit',
    method: 'post',
    data: row
  })
}

export const enAble = (data) => {
  return request({
    url: '/user/rpauser/enAble',
    method: 'post',
    data: data
  })
}
